export class ListZeroEtlJobsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ZeroEtlJobsFilters",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<ZeroEtlJobsSort>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlJobsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
